<template>
  <div class="button" id= 'button'>
    <button id= 'buttons' @click="clickBtn" ref="buttonDOM" :class="type === 'back' || type === 'tosignup' ? 'white' : ''" :style="{cursor: (!loading ? 'pointer' : 'not-allowed')}">
      <span v-show="!loading">{{params[type].text}}</span>
      <img v-show="loading" class="rolling" :src="rolling">
    </button>
  </div>
</template>

<script>
  import Vue from 'vue'
  import config from '@/assets/js/config'
  import CryptoJS from 'crypto-js'
  import { post, checkScan } from '../common/Axios.js'
  import { checkDevice, checkEmpty, checkEmail, checkPhone, checkInputAccount, transferData, getLocationHash, getPublicKey, getMD5, browserLanguage, addOldUserName, getInviteName, getInviteType, getInviteGroup, getInviteTeam } from '../common/Common.js'
  import uploadWebEvent from '../common/UploadWebEvent.js'
  import translate from '../common/Translate.js'
  export default {
    data () {
      return {
        rolling: require('../../assets/images/new-login-2018/rolling.gif'),
        loading: false,
        params: {
          // 点击加入邀请
          join: {
            type: 'join',
            text: translate('Join'),
            fn: async function () {
              if (!checkEmpty(this.data)) {
                this.$emit('openErrorTip', 'EMPTY_ACCOUNT')
                return false
              } else {
                let {type, password, account} = this.data
                let publicKey = getPublicKey(account)
                let obj = {}
                let that = this
                let callback1 = function (msg, status) {
                  if (status !== '0') {
                    that.$emit('openErrorTip', msg)
                    that.loading = false
                  }
                }
                let callback2 = function (msg, status) {
                  // 埋点统计：邀请登录页面登录结果
                  uploadWebEvent('INVITE_JOIN_PASSWORD_RESULT', {
                    type,
                    status
                  })
                  if (status !== '0') {
                    that.$emit('openErrorTip', msg)
                    that.loading = false
                  }
                }
                // 判断密码是否为空
                if (!checkEmpty(password)) {
                  // 埋点统计：邀请登录页面提示密码不合法
                  uploadWebEvent('INVITE_JOIN_PASSWORD_ERROR', {
                    type
                  })
                  this.$emit('openErrorTip', 'EMPTY_PASSWORD')
                  return false
                }
                this.loading = true
                if (type === 0) {
                  obj = {
                    email: account,
                    password: password,
                    key_md5: getMD5(publicKey),
                    from: 'invite'
                  }
                } else if (type === 1) {
                  obj = {
                    phone_md5: getMD5(account),
                    password: password,
                    key_md5: getMD5(publicKey),
                    from: 'invite'
                  }
                } else {
                  obj = {
                    account_id: account,
                    password: password,
                    key_md5: getMD5(publicKey),
                    from: 'invite'
                  }
                }
                let res = await post('/proxy-api/client/user/index/web-login', obj, callback1, getLocationHash())
                let code = res.data.payload.code
                await post('/proxy-api/client/web/index/share-complete-new', {code: code, invite_token: this.$route.query['token'], from: this.$route.query['from'], language: browserLanguage()}, callback2, getLocationHash())
                let route = {
                  path: '/invite/invitesuccess',
                  query: {
                    account: account,
                    type: 3
                  }
                }
                return route
              }
            }.bind(this)
          },
          // 输入账号点击登录
          signin: {
            type: 'signin',
            text: 'Sign in',
            fn: async function () {
              if (!checkEmpty(this.data)) {
                this.$emit('openErrorTip', 'EMPTY_ACCOUNT')
                return false
              } else {
                this.loading = true
                let that = this
                let callback = function (msg, status) {
                  if (status !== '0') {
                    that.$emit('openErrorTip', msg)
                    that.loading = false
                  }
                }
                // 检测账号是否存在
                let res = await post('/proxy-api/client/web/index/check-account-exist', {account: this.data}, callback, getLocationHash())
                let user = res.data.payload.user
                if (res.data.payload.is_exist === 1) {
                  let countryCode = user.countryCode || ''
                  let publicKey = getPublicKey(this.data)
                  let keyMd5 = CryptoJS.MD5(publicKey).toString().substr(8, 16)
                  let route = {
                    query: {
                      account: this.data,
                      countryCode: countryCode,
                      showTip: true
                    }
                  }
                  // 检测是否需要扫码
                  let res = await checkScan(route, {account: this.data, key_md5: keyMd5}, callback, getLocationHash())
                  let type = 2
                  if (checkEmail(this.data)) type = 0
                  if (checkPhone(this.data)) type = 1
                  if (res.path === '/login/scan') {
                    // 埋点统计：登录页面输入强制跳转到扫码
                    uploadWebEvent('SIGNIN_INPUT_TO_SCAN', {
                      type
                    })
                    return res
                  } else if (res.path === '/login/password') {
                    // 埋点统计：登录页面输入强制跳转到下一步登录
                    uploadWebEvent('SIGNIN_INPUT_TO_NEXT', {
                      type
                    })
                    this.$emit('showPassword', true)
                    return false
                  }
                } else {
                  let that = this
                  let callback = function (msg, status) {
                    if (status !== '0') {
                      that.$emit('openErrorTip', msg)
                      that.loading = false
                    }
                  }
                  if (checkInputAccount(this.data, callback, 'signin')) {
                    uploadWebEvent('SIGNIN_ACCOUNT_NOT_EXIST') // 埋点统计：登录页面输入并提示账号不存在
                    this.$emit('accountNotExist')
                    return false
                  }
                }
              }
            }.bind(this)
          },
          // 输入密码点击登录
          login: {
            type: 'login',
            text: 'Sign in',
            fn: async function () {
              let {type, password, account} = this.data
              let publicKey = getPublicKey(account)
              let obj = {}
              let that = this
              let callback = function (msg, status, payload) {
                // 埋点统计：登录输入密码登录结果
                uploadWebEvent('SIGNIN_PASSWORD_RESULT', {
                  type,
                  status
                })
                if (status !== '0') {
                  that.$emit('openErrorTip', msg)
                  that.loading = false
                  if (+payload['need_scan'] === 1) that.$emit('loginSuccess')
                } else {
                  that.$emit('loginSuccess', password)
                }
              }
              // 判断密码是否为空
              if (!checkEmpty(password)) {
                this.$emit('openErrorTip', 'EMPTY_PASSWORD')
                return false
              }
              this.loading = true
              if (type === 0) {
                obj = {
                  email: account,
                  password: password,
                  key_md5: getMD5(publicKey)
                }
              } else if (type === 1) {
                obj = {
                  phone_md5: getMD5(account),
                  password: password,
                  key_md5: getMD5(publicKey)
                }
              } else {
                obj = {
                  account_id: account,
                  password: password,
                  key_md5: getMD5(publicKey)
                }
              }
              await post('/proxy-api/client/user/index/web-login', obj, callback)
              return false
            }.bind(this)
          },
          // 点击继续
          continue: {
            type: 'continue',
            text: translate('Continue'),
            fn: async function () {
              if (!checkEmpty(this.data)) {
                this.$emit('openErrorTip', 'EMPTY_ACCOUNT')
                return false
              } else {
                this.loading = true
                let that = this
                let callback = function (msg, status) {
                  if (status !== '0') {
                    that.$emit('openErrorTip', msg)
                    that.loading = false
                  }
                }
                // 检测账号是否存在
                let res = await post('/proxy-api/client/web/index/check-account-exist', {account: this.data}, callback, getLocationHash())
                let route = {
                  query: {
                    account: this.data
                  }
                }
                if (res.data.payload.is_exist === 0) {
                  if (checkInputAccount(this.data, callback, 'signup')) {
                    if (config.isLogin) {
                      route['path'] = '/login/signupnext'
                    } else {
                      route['query']['token'] = this.$route.query['token']
                      route['query']['from'] = this.$route.query['from']
                      route['path'] = '/invite/invitenext'
                    }
                    return route
                  } else {
                    return false
                  }
                } else {
                  if (config.isLogin) {
                    uploadWebEvent('SIGNUP_ACCOUNT_EXIST') // 埋点统计：注册页面提示账号已存在
                    this.$emit('accountExist')
                    return false
                  } else {
                    uploadWebEvent('INVITE_ACCOUNT_EXIST') // 埋点统计：邀请页面提示账号已存在
                    route['query']['token'] = this.$route.query['token']
                    route['query']['from'] = this.$route.query['from']
                    route['path'] = '/invite/accountexist'
                    return route
                  }
                }
              }
            }.bind(this)
          },
          // 点击重置密码
          reset: {
            type: 'reset',
            text: 'Reset password',
            fn: async function () {
              let {account, countryCode, isEmail} = this.$route.query
              let {code, password} = this.data
              let type = isEmail === true || isEmail === 'true' ? 0 : 1
              let that = this
              let callback = function (msg, status) {
                // 埋点统计：重置密码结果
                uploadWebEvent('RESET_PASSWORD_RESULT', {
                  type,
                  status
                })
                if (status !== '0') {
                  that.$emit('openErrorTip', msg)
                  that.loading = false
                }
              }
              // 判断验证码是否为空
              if (!checkEmpty(code)) {
                // 埋点统计：重置密码页面验证码错误
                uploadWebEvent('RESET_PASSWORD_ERROR', {
                  type
                })
                this.$emit('openErrorTip', 'EMPTY_CODE')
                return false
              }
              // 判断密码是否为空
              if (!checkEmpty(password)) {
                // 埋点统计：重置密码页面验证码错误
                uploadWebEvent('RESET_PASSWORD_ERROR', {
                  type
                })
                this.$emit('openErrorTip', 'EMPTY_PASSWORD')
                return false
              }
              // 判断密码是否少于六位
              if (password.length < 6) {
                // 埋点统计：重置密码页面验证码错误
                uploadWebEvent('RESET_PASSWORD_ERROR', {
                  type
                })
                this.$emit('openErrorTip', 'INVALID_PASSWORD')
                return false
              }
              this.loading = true
              if (type === 0) {
                await post('/proxy-api/client/web/index/reset-password-by-email', {email: account, capture: code, password: password}, callback, getLocationHash())
                return {path: '/login/resetsuccess'}
              } else {
                let callback2 = function (msg, status) {
                  if (status !== '0') {
                    that.$emit('openErrorTip', msg)
                    that.loading = false
                  }
                }
                let res = await post('/proxy-api/client/phone/index/validate-capture', {phone_num: account, country_code: countryCode, capture: code, type: 1, language: browserLanguage()}, callback2, getLocationHash())
                let validateToken = res.data.payload['validate_token']
                await post('/proxy-api/client/phone/index/forget-password', {phone_md5: CryptoJS.MD5(account).toString().substr(8, 16), password: password, validate_token: validateToken}, callback, getLocationHash())
                return {path: '/login/resetsuccess'}
              }
            }.bind(this)
          },
          // 回退
          back: {
            type: 'back',
            text: translate('Back'),
            fn: function () {
              let type = this.data ? this.data.type : 3
              if (config.isLogin) {
                // 埋点统计：注册页面返回上一步
                uploadWebEvent('SIGNUP_BACK', {
                  type
                })
              } else {
                // 埋点统计：邀请页面返回上一步
                uploadWebEvent('INVITE_BACK', {
                  type
                })
              }
              history.back()
              return false
            }.bind(this)
          },
          // 下一步
          next: {
            type: 'next',
            text: translate('Next'),
            fn: function () {
              if (config.isLogin) {
                uploadWebEvent('SIGNUPNEXT_PHONE_NEXT') // 埋点统计：手机号注册姓名密码页点击下一步
              } else {
                uploadWebEvent('INVITENEXT_PHONE_NEXT') // 埋点统计：手机号邀请姓名密码页点击下一步
              }
              let {username, password, account} = this.data
              // 判断name是否为空
              if (!checkEmpty(username)) {
                if (config.isLogin) {
                  uploadWebEvent('SIGNUPNEXT_PHONE_ERROR') // 埋点统计：手机号注册姓名密码页提示输入错误
                } else {
                  uploadWebEvent('INVITENEXT_PHONE_ERROR') // 埋点统计：手机号邀请姓名密码页提示输入错误
                }
                this.$emit('openErrorTip', 'EMPTY_NAME')
                return false
              }
              // 判断密码是否为空
              if (!checkEmpty(password)) {
                if (config.isLogin) {
                  uploadWebEvent('SIGNUPNEXT_PHONE_ERROR') // 埋点统计：手机号注册姓名密码页提示输入错误
                } else {
                  uploadWebEvent('INVITENEXT_PHONE_ERROR') // 埋点统计：手机号邀请姓名密码页提示输入错误
                }
                this.$emit('openErrorTip', 'EMPTY_PASSWORD')
                return false
              }
              // 判断密码是否少于六位
              if (password && password.length < 6) {
                if (config.isLogin) {
                  uploadWebEvent('SIGNUPNEXT_PHONE_ERROR') // 埋点统计：手机号注册姓名密码页提示输入错误
                } else {
                  uploadWebEvent('INVITENEXT_PHONE_ERROR') // 埋点统计：手机号邀请姓名密码页提示输入错误
                }
                this.$emit('openErrorTip', 'INVALID_PASSWORD')
                return false
              }
              let route = {
                query: {
                  account: account
                }
              }
              if (config.isLogin) {
                route['path'] = '/login/signupphone'
              } else {
                route['query']['token'] = this.$route.query['token']
                route['query']['from'] = this.$route.query['from']
                route['path'] = '/invite/invitephone'
              }
              transferData.saveData(this.data)
              return route
            }.bind(this)
          },
          // 完成
          done: {
            type: 'done',
            text: translate('Done'),
            fn: async function (from) {
              let {type, username, password, account, capture, countryCode} = this.data
              from = 'verifyLater'
              let validateToken
              let encryptStr
              let that = this
              let callback = function (msg, status) {
                if (config.isLogin) {
                  // 埋点统计：注册结果
                  uploadWebEvent('SIGNUP_RESULT', {
                    type,
                    status,
                    from
                  })
                } else {
                  // 埋点统计：邀请注册结果
                  uploadWebEvent('INVITE_RESULT', {
                    type,
                    status,
                    from
                  })
                }
                if (status !== '0') {
                  that.$emit('openErrorTip', msg)
                  that.loading = false
                }
              }
              let callback2 = function (msg, status) {
                if (status !== '0') {
                  that.$emit('openErrorTip', msg)
                  that.loading = false
                }
              }
              // 判断手机号是否有效
              if (type === 1) {
                if (!checkPhone(account || this.$route.query['account'])) {
                  if (config.isLogin) {
                    // 埋点统计：注册密码完成页输入错误
                    uploadWebEvent('SIGNUPNEXT_DONE_ERROR', {
                      type
                    })
                  } else {
                    // 埋点统计：邀请密码完成页输入错误
                    uploadWebEvent('INVITENEXT_DONE_ERROR', {
                      type
                    })
                  }
                  this.$emit('openErrorTip', 'INVALID_PHONE')
                  return false
                }
              }
              // 判断name是否为空
              if (!checkEmpty(username)) {
                if (config.isLogin) {
                  // 埋点统计：注册密码完成页输入错误
                  uploadWebEvent('SIGNUPNEXT_DONE_ERROR', {
                    type
                  })
                } else {
                  // 埋点统计：邀请密码完成页输入错误
                  uploadWebEvent('INVITENEXT_DONE_ERROR', {
                    type
                  })
                }
                this.$emit('openErrorTip', 'EMPTY_NAME')
                return false
              }
              // 判断验证码是否为空
              // if (!checkEmpty(countryCode)) {
              //   if (config.isLogin) {
              //     // 埋点统计：注册密码完成页输入错误
              //     uploadWebEvent('SIGNUPNEXT_DONE_ERROR', {
              //       type
              //     })
              //   } else {
              //     // 埋点统计：邀请密码完成页输入错误
              //     uploadWebEvent('INVITENEXT_DONE_ERROR', {
              //       type
              //     })
              //   }
              //   this.$emit('openErrorTip', 'EMPTY_CODE')
              //   return false
              // }
              // 判断密码是否为空
              if (!checkEmpty(password)) {
                if (config.isLogin) {
                  // 埋点统计：注册密码完成页输入错误
                  uploadWebEvent('SIGNUPNEXT_DONE_ERROR', {
                    type
                  })
                } else {
                  // 埋点统计：邀请密码完成页输入错误
                  uploadWebEvent('INVITENEXT_DONE_ERROR', {
                    type
                  })
                }
                this.$emit('openErrorTip', 'EMPTY_PASSWORD')
                return false
              }
              // 判断密码是否少于六位
              if (password && password.length < 6) {
                if (config.isLogin) {
                  // 埋点统计：注册密码完成页输入错误
                  uploadWebEvent('SIGNUPNEXT_DONE_ERROR', {
                    type
                  })
                } else {
                  // 埋点统计：邀请密码完成页输入错误
                  uploadWebEvent('INVITENEXT_DONE_ERROR', {
                    type
                  })
                }
                this.$emit('openErrorTip', 'INVALID_PASSWORD')
                return false
              }
              // 判断验证码是否为空
              // if (capture === '' && from !== 'verifyLater') {
              //   if (config.isLogin) {
              //     // 埋点统计：注册密码完成页输入错误
              //     uploadWebEvent('SIGNUPNEXT_DONE_ERROR', {
              //       type
              //     })
              //   } else {
              //     // 埋点统计：邀请密码完成页输入错误
              //     uploadWebEvent('INVITENEXT_DONE_ERROR', {
              //       type
              //     })
              //   }
              //   this.$emit('openErrorTip', 'EMPTY_CODE')
              //   return false
              // }
              this.loading = true
              if (type === 0) {
                let obj = {
                  email: account,
                  password: password
                }
                encryptStr = JSON.stringify(obj)
              } else if (type === 1) {
                account = account || this.$route.query['account']
                if (from !== 'verifyLater') {
                  let res = await post('/proxy-api/client/phone/index/validate-capture', {capture: capture, country_code: countryCode, type: 0, phone_num: account, language: browserLanguage()}, callback2, getLocationHash())
                  validateToken = res.data.payload['validate_token']
                  encryptStr = countryCode + '|' + account + '|' + password + '|' + validateToken
                } else { // 稍后验证，跳过验证码接口
                  encryptStr = countryCode + '|' + account + '|' + password
                }
              } else {
                let obj = {
                  account_id: account,
                  password: password
                }
                encryptStr = JSON.stringify(obj)
              }
              let res = await post('/proxy-api/client/user/index/register', {username: '', type: type, invite_token: this.$route.query['token'], encrypt_str: window.btoa(encryptStr), language: browserLanguage()}, callback, getLocationHash())
              let code = res.data.payload.code
              let route = {
                query: {
                  account: account
                }
              }
              if (config.isLogin) {
                route['path'] = '/login/signupsuccess'
              } else {
                await post('/proxy-api/client/web/index/share-complete-new', {code: code, invite_token: this.$route.query['token'], from: this.$route.query['from'], language: browserLanguage()}, callback2, getLocationHash())
                route['query']['type'] = type
                route['path'] = '/invite/invitesuccess'
              }
              return route
            }.bind(this)
          },
          // 下载
          open: {
            type: 'open',
            text: this.$route.query['user'] === 'old' ? translate('Open/Download Crait') : translate('Download Crait'),
            fn: async function () {
              let data = this.$route.query.account
              let publicKey = getPublicKey(data)
              let keyMd5 = CryptoJS.MD5(publicKey).toString().substr(8, 16)
              let route = {
                query: {
                  account: data,
                  countryCode: '',
                  showTip: true
                }
              }
              if (config.isLogin) {
                // 检测是否需要扫码
                let res = await checkScan(route, {account: data, key_md5: keyMd5}, '', getLocationHash())
                return res
              } else {
                if (config.type === 'newInvite') {
                  uploadWebEvent('DOWNLOAD', {
                    type: this.$route.query['user'] === 'old' ? 1 : 0
                  })
                } else {
                  // 埋点统计：邀请成功界面点击Download/Open Crait
                  uploadWebEvent('INVITE_SUCCESS_OPEN', {
                    type: this.$route.query.type
                  })
                }
                if (checkDevice()) {
                  // location.href = 'https://www.craitapp.com/login/index.html#/login/signin'
                  location.href = 'https://dl.craitapp.com/?action=open&cmd=login&username=' + data
                } else {
                  // location.href = 'https://pre.craitapp.com/website/mweb/index.html?action=open&cmd=login&username=' + data
                  // location.href = 'https://share.craitapp.com/mweb/index.html?action=open&cmd=login&username=' + data
                  location.href = 'https://dl.craitapp.com/?action=open&cmd=login&username=' + data
                }
                return false
              }
            }.bind(this)
          },
          // 前往注册页
          tosignup: {
            type: 'tosignup',
            text: checkDevice() ? translate('Go to sign up page') : translate('Open/Download Crait'),
            fn: function () {
              location.href = 'https://craitapp.com/login/index.html#/login/signup'
            }
          },
          // 开始安全通信
          StartSecureMessaging: {
            type: 'StartSecureMessaging',
            text: translate('Start secure messaging'),
            fn: async function () {
              if (!checkEmpty(this.data)) {
                this.$emit('openErrorTip', 'EMPTY_ACCOUNT')
                return false
              } else {
                this.loading = true
                let that = this
                let callback = function (msg, status) {
                  if (status !== '0') {
                    checkInputAccount(that.data, function (error) {
                      that.$emit('openErrorTip', error || msg)
                    }, '', 0)
                    // that.$emit('openErrorTip', msg)
                    that.loading = false
                  }
                }
                // 检测账号是否存在
                let res = await post('/proxy-api/client/web/index/check-account-exist', {account: this.data, language: browserLanguage(), invite_token: this.$route.query['token']}, callback, getLocationHash())
                let route = {
                  query: {
                  }
                }
                if (res.data.payload.is_exist === 0) {
                  if (config.type === 'newInvite') {
                    // 埋点统计：首页_开始安全通信 新用户
                    uploadWebEvent('START', {
                      type: 0
                    })
                  }
                  if (checkInputAccount(this.data, callback, '', 1)) {
                    route.query['user'] = 'new'
                    route.query['account'] = this.data
                    route.query['invitename'] = getInviteName()
                    route.query['invitetype'] = getInviteType()
                    route.query['invitegroup'] = getInviteGroup()
                    route.query['inviteTeam'] = getInviteTeam()
                    route['path'] = '/invite/invitesuccess'
                    return route
                  } else {
                    return false
                  }
                } else if (res.data.payload.is_exist === 1) {
                  if (config.type === 'newInvite') {
                    // 埋点统计：首页_开始安全通信 老用户
                    uploadWebEvent('START', {
                      type: 1
                    })
                  }
                  addOldUserName(res.data.payload.user.username)
                  route.query['account'] = this.data
                  route.query['type'] = this.$route.query['type']
                  route.query['token'] = this.$route.query['token']
                  route.query['name'] = res.data.payload.user.username
                  route.query['invitename'] = getInviteName()
                  route.query['invitetype'] = getInviteType()
                  route.query['invitegroup'] = getInviteGroup()
                  route.query['inviteTeam'] = getInviteTeam()
                  if (this.$route.query['source']) route.query['fromwebsite'] = 'true'
                  route['path'] = '/invite/invitenext'
                  return route
                } else {
                  checkInputAccount(this.data, function () {}, '', 0)
                  return false
                }
              }
            }.bind(this)
          },
          // 接受邀请
          Accept: {
            type: 'Accept',
            text: translate('Accept'),
            fn: async function () {
              let {type, password, account} = this.data
              let publicKey = getPublicKey(account)
              let obj = {}
              let that = this
              let callback1 = function (msg, status) {
                if (status !== '0') {
                  uploadWebEvent('ACCEPT', {
                    result: 0
                  })
                  that.$emit('openErrorTip', msg)
                  that.loading = false
                } else {
                  uploadWebEvent('ACCEPT', {
                    result: 1
                  })
                }
              }
              let callback2 = function (msg, status) {
                if (status !== '0') {
                  that.$emit('openErrorTip', msg)
                  that.loading = false
                }
              }
              // 判断密码是否为空
              if (!checkEmpty(password)) {
                this.$emit('openErrorTip', 'EMPTY_PASSWORD')
                return false
              }
              this.loading = true
              if (type === 0) {
                obj = {
                  email: account,
                  password: password,
                  key_md5: getMD5(publicKey),
                  from: 'invite'
                }
              } else if (type === 1) {
                obj = {
                  phone_md5: getMD5(account),
                  password: password,
                  key_md5: getMD5(publicKey),
                  from: 'invite'
                }
              } else {
                obj = {
                  account_id: account,
                  password: password,
                  key_md5: getMD5(publicKey),
                  from: 'invite'
                }
              }
              obj['language'] = browserLanguage()
              let res = await post('/proxy-api/client/user/index/web-login', obj, callback1, getLocationHash())
              let code = res.data.payload.code
              await post('/proxy-api/client/web/index/share-complete-new', {code: code, invite_token: this.$route.query['token'], from: this.$route.query['from'], language: browserLanguage()}, callback2, getLocationHash())
              let route = {
                path: '/invite/invitesuccess',
                query: {
                  user: 'old',
                  account: this.$route.query['account'],
                  invitename: this.$route.query['invitename'],
                  invitetype: this.$route.query['invitetype'],
                  invitegroup: this.$route.query['invitegroup'],
                  inviteTeam: this.$route.query['inviteTeam']
                }
              }
              return route
            }.bind(this)
          }
        }
      }
    },
    props: ['type', 'data'],
    mounted () {
      if (this.type === 'tosignup') this.complie()
      if (!checkDevice()) {
        let button = document.getElementById('button')
        // mobile reset width.
        button.style.width = '100%'

        let buttons = document.getElementById('buttons')
        // reset 86% width.
        buttons.style.width = '86%'
        // element center.
        buttons.style.margin = '0 auto'
      }
    },
    methods: {
      complie () {
        let href = ''
        if (checkDevice()) {
          href = 'https://craitapp.com/login/index.html#/login/signup'
        } else {
          // href = 'https://pre.craitapp.com/website/mweb/index.html?action=open&cmd=login&username='
          href = 'https://share.craitapp.com/mweb/index.html?action=open&cmd=login&username='
        }
        const Component = Vue.extend({
          template: '<a :href="href" style="width: 200px; height: 40px; display: inherit; margin: -30px 0 0 -11px;"></a>',
          props: ['href']
        })
        const component = new Component({
          propsData: {
            href
          }
        }).$mount()
        this.$refs['buttonDOM'].appendChild(component.$el)
      },
      async clickBtn (from) {
        if (!this.loading) {
          this.$emit('closeErrorTip')
          let res = await this.params[this.type].fn(from)
          this.loading = false
          if (res !== false) this.$router.push(res)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
	.button {
    width: 300px;
    height: 40px;
    margin: 0 auto;
    margin-top: 30px;
    button {
      font-size: 14px;
      width: 100%;
      height: 40px;
      color: #ffffff;
      display: inherit;
      padding: 10px;
      background: #3f86de;
      border: 1px solid #3f86de;
      border-radius: 2px;
      cursor: pointer;
      .rolling {
        margin-top: -7px;
        outline: none;
        width: 30px;
        height: 30px;
      }
      a {
        width: 200px;
        height: 40px;
        display: inherit;
        margin: -30px 0 0 -11px;
      }
    }
    .white {
      background: #ffffff; 
      color: #3f86de;
    }
  }
</style>



// WEBPACK FOOTER //
// Buttons.vue?91de6498